import React from "react";
import Child from "./Child";
import classNames from "../classNames";

const defaultIcon = "bi bi-journal-text";
const defaultProps = {
  onClick: () => {},
};

function Item({ menu, onClick, activeItem, setActiveItem, currentPath }) {
  const { name, icon, label, disabled } = menu;
  const route = menu.route || "/" + name;

  // Check if active based on activeItem state or current pathname
  const isActive =
    activeItem === route ||
    (currentPath &&
      (currentPath === route ||
        (route !== "/" && currentPath.startsWith(route))));

  if (Array.isArray(route)) {
    return (
      <Child
        menu={menu}
        onClick={onClick}
        setActiveItem={setActiveItem}
        activeItem={activeItem}
        currentPath={currentPath}
      />
    );
  }

  return (
    <li className="nav-item mb-1" key={route}>
      <a
        onClick={(e) => {
          e.preventDefault();
          if (!disabled && setActiveItem) setActiveItem(route);
          if (!disabled) onClick(e, menu);
        }}
        href={route}
        className={`nav-link text-truncate ${isActive ? "bg-primary" : "bg-white"} ${disabled ? "disabled" : ""}`}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0.75rem 1rem",
          borderRadius: "8px",
          color: isActive ? "#ffffff" : "#495057",
          textDecoration: "none",
          transition: "all 0.2s ease",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.5 : 1,
          fontWeight: isActive ? "600" : "500",
          fontSize: "0.95rem",
        }}
        onMouseEnter={(e) => {
          if (!disabled && !isActive) {
            e.currentTarget.style.backgroundColor = "#f8f9fa";
            e.currentTarget.style.color = "#283754";
          }
        }}
        onMouseLeave={(e) => {
          if (!disabled) {
            e.currentTarget.style.backgroundColor = isActive
              ? "#283754"
              : "transparent";
            e.currentTarget.style.color = isActive ? "#ffffff" : "#495057";
          }
        }}
      >
        <i
          className={icon || "bi bi-journal-text"}
          style={{
            fontSize: "1.1rem",
            width: "20px",
            textAlign: "center",
          }}
        ></i>
        <span style={{ marginLeft: "0.75rem", flex: 1 }}>{label || name}</span>
      </a>
    </li>
  );
}

Item.defaultProps = defaultProps;
export default Item;
